'use client'

import type { MenuItem, MenuSeparator } from '@graftcode/design-system'
import { Icon } from '@graftcode/design-system'

export const HELP_ITEM_ID = {
  PORTAL_ONBOARDING: 'help-portal-onboarding',
  DOCS: 'help-docs',
  CHANGELOG: 'help-changelog',
  SHARE_FEEDBACK: 'help-share-feedback',
  KEYBOARD_SHORTCUTS: 'help-keyboard-shortcuts',
  DISCORD: 'help-discord',
} as const

export const HELP_ITEM_URLS: Record<string, string> = {
  [HELP_ITEM_ID.DOCS]: 'https://docs.graftcode.com',
  [HELP_ITEM_ID.CHANGELOG]: 'https://graftcode.featurebase.app/en/roadmap',
  [HELP_ITEM_ID.DISCORD]: 'https://discord.gg/2tWb3BAE36',
}

export const DEFAULT_HELP_ITEMS: (MenuItem | MenuSeparator)[] = [
  {
    type: 'item',
    active: true,
    groups: [],
    icon: Icon.BookOpenRegular,
    label: 'Docs',
    id: HELP_ITEM_ID.DOCS,
    size: 'xs',
  },
  {
    type: 'item',
    active: true,
    groups: [],
    icon: Icon.TextBulletListRegular,
    label: 'Changelog',
    id: HELP_ITEM_ID.CHANGELOG,
    size: 'xs',
  },
  {
    type: 'item',
    active: true,
    groups: [],
    icon: Icon.LightbulbFilamentRegular,
    label: 'Share feedback',
    id: HELP_ITEM_ID.SHARE_FEEDBACK,
    size: 'xs',
  },
  {
    type: 'item',
    active: false,
    groups: [],
    icon: Icon.ArrowEnterLeftRegular,
    label: 'Keyboard shortcuts',
    id: HELP_ITEM_ID.KEYBOARD_SHORTCUTS,
    size: 'xs',
  },
  {
    id: 'help-sep-1',
    type: 'separator',
  },
  {
    type: 'item',
    active: true,
    groups: [],
    icon: Icon.DSDiscordBlack,
    label: 'Community (Discord)',
    id: HELP_ITEM_ID.DISCORD,
    size: 'xs',
  },
]
